<template>
    <div class="componentRoot">
        <RouterView />
    </div>
</template>



<script>
export default {
    name: "settingsRoot",

    data() {
        return {

        }
    },

    computed: {
        isMobile() {
            switch (this.$vuetify.display.name) {
                case "xs":
                    return true;
                case "sm":
                    return true;
                case "md":
                    return false;
                case "lg":
                    return false;
                case "xl":
                    return false;
                case "xxl":
                    return false;
                default:
                    return false;
            }
        },
    },

    methods: {
    }
}

</script>